import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BackToTop } from "@/components/ui/back-to-top";
import Header from "@/components/layout/header.tsx";
import Footer from "@/components/layout/footer.tsx";
import Home from "@/pages/home.tsx";
import About from "@/pages/about.tsx";
import Books from "@/pages/books.tsx";
import Blog from "@/pages/blog";
import BlogPost from "@/pages/blog-post";
import BlogArchive from "@/pages/blog-archive";
import NewsEvents from "@/pages/news-events";
import Contact from "@/pages/contact.tsx";
import PrivacyPolicy from "@/pages/privacy-policy.tsx";
import TermsOfService from "@/pages/terms-of-service.tsx";
import NotFound from "@/pages/not-found.tsx";
import AdminLogin from "@/pages/admin-login";
import AdminDashboard from "@/pages/admin-dashboard";
import Quiz from "@/pages/quiz";

import { useRef } from "react";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SplitTestPopup, type SplitTestPopupRef } from "@/components/SplitTestPopup";
import AdminSplitTest from "@/pages/admin/split-test";
import SubscribePopup from "@/components/SubscribePopup";
import CookieBanner from "@/components/CookieBanner";

function Router({ onOpenMailingList }: { onOpenMailingList: () => void }) {
  return (
    <div className="min-h-screen bg-gothic-black text-gothic-white">
      <ScrollToTop />
      <Header />
      <main>
        <Switch>
          <Route path="/">
            <Home onOpenMailingList={onOpenMailingList} />
          </Route>
          <Route path="/about" component={About} />
          <Route path="/books" component={Books} />
          <Route path="/blog" component={Blog} />
          <Route path="/blog/archive" component={BlogArchive} />
          <Route path="/blog/:slug" component={BlogPost} />
          <Route path="/news-events" component={NewsEvents} />
          <Route path="/contact" component={Contact} />
          <Route path="/privacy" component={PrivacyPolicy} />
          <Route path="/terms" component={TermsOfService} />
          <Route path="/admin/login" component={AdminLogin} />
          <Route path="/admin/dashboard" component={AdminDashboard} />
          <Route path="/admin/split-test" component={AdminSplitTest} />
          <Route path="/quiz" component={Quiz} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer onOpenMailingList={onOpenMailingList} />
      <BackToTop />
    </div>
  );
}

function App() {
  const popupRef = useRef<SplitTestPopupRef>(null);

  const handleOpenMailingList = () => {
    popupRef.current?.openManual();
  };

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Router onOpenMailingList={handleOpenMailingList} />
          <SplitTestPopup ref={popupRef} />
          <SubscribePopup />
          <CookieBanner />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;